import React from 'react';
import { Link } from 'react-router-dom'

export default function Regulation30(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Regulation 30</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Regulation 30</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			  <div className="table-responsive table_heading">
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2026-27</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>Web Link to Annual Report</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Web-Link-to-Annual-Report.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Appointment of Statutory Auditor</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Appointment-of-Statutory-Auditor.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> <tr>
					  <td>Intimation of 41st AGM schdule of company</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Intimation-of-41st-AGM-schdule-of-company.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> <tr>
					  <td>Resignation of Statutory Auditors</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Resignation-of-Statutory-Auditors.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> <tr>
					  <td>Appointment of Additional Director</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Appointment-of-Additional-Director.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>Chnage in Composition of Committee 10-08-2026</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Chnage-in-Composition-of-Committee-10-08-2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Resignation of Director</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2026-27/Resignation-of-Director.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
				
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2025-26</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>Amendments In MOA & AOA</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Amendments-In-MOA-&-AOA.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>Regularisation of Directors</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Regularisation-of-Directors.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Reg 30 Appointment of additional director</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Reg-30-appointment-of-additional-director.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Appointment Of Company Secretary</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/d93e301c-21e9-4ff1-8fad-f413971e056c.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Chnage in Mgt. 07-07-2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Chnage-in-Mgt-07-07-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Chnage in Mgt. 07-07-2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Chnage-in-Mgt-07-07-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					 <tr>
					  <td>Resignation of  CS-26.05.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/Resignation_of_CS_26.05.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  <tr>
					  <td>Outcomes Of BM FR-14.05.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2025-26/outcomes_of_bm_FR_14.05.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				 
					
					
				  </tbody>
				</table>
			  </div>
			  
			  <div className="table-responsive table_heading">
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2024-25</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
					
					<tr>
					  <td>Appointment of cs_08.08.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2024-25/appointment-of-cs_08.08.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation of 39th AGM 02.09.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2024-25/intimation-of-39th-AGM_02.09.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>Resignation of WTD 04.10.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Reg-30/2024-25/resignationof-WTD-04.10.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				  </tbody>
				</table>
			  </div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}